;(function () {
    let target = null
    const products = document.body.querySelector(".products")

    if (products) {
        target = products
    }

    const posts = document.body.querySelector(".inspiration-posts")

    if (posts) {
        target = posts
    }

    if (!target) {
        return
    }

    // Create a nice offset
    target.style.setProperty("scroll-margin-block", "15rem")
    document.addEventListener("facetwp-refresh", () => {

        if ( FWP.soft_refresh == true ) {
            FWP.enable_scroll = true;
            console.log('test1')
        } else {
            FWP.enable_scroll = false;
            console.log('test2')
        }
    })

    document.addEventListener("facetwp-refresh", () => {
        if (FWP.enable_scroll) {
            target.scrollIntoView({
                behavior: "smooth",
                block: "start",
            })
        }
    })

})()
